export type EditorFontPreference = 'mono' | 'prose'

export function getDefaultEditorFontPreference(path: string | null): EditorFontPreference {
    return path?.toLowerCase().endsWith('.md') ? 'prose' : 'mono'
}

export function getEditorFontClass(
    path: string | null,
    forcedFont: EditorFontPreference | null,
): 'editor-mono' | 'editor-proportional' {
    const font = forcedFont ?? getDefaultEditorFontPreference(path)
    return font === 'prose' ? 'editor-proportional' : 'editor-mono'
}
